import AccessServiceTypes from 'app/domain/AccessServiceTypes';
import { ContentItemFragment, Presentation } from 'app/graphql/__generated__/types/contento';
import ContinueWatching from 'app/utils/models/ContinueWatching';
import React from 'react';
import { InView } from 'react-intersection-observer';
import { Props as ContentItemProps } from '../ContentItem/ContentItem';
import { getProgress } from '../ContentItemCarousel/helpers';
import { ContentItemGridBlock, StyledContentItemGrid } from './ContentItemGrid.styles';

type Props = {
    items: Array<ContentItemFragment>;
    id: string;
    editModeActivated?: boolean;
    presentation?: Presentation;
    preferredAccessVersion?: AccessServiceTypes;
    onItemClick: (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        itemPosition: number,
        svtId: string,
        autoPlay?: boolean,
        b?: boolean
    ) => void;
    onItemImpression: (target: any, ...args: any) => void;
    continueWatchingIsActive?: boolean;
    shouldUseIntersectionObserver?: boolean;
    autoPlay?: boolean;
    onMarkedAsDeleted?: (item: ContinueWatching) => void;
};

const ContentItemGrid = (props: Props): JSX.Element => {
    const {
        items,
        id,
        editModeActivated = false,
        presentation,
        preferredAccessVersion,
        onItemClick,
        onItemImpression,
        continueWatchingIsActive,
        shouldUseIntersectionObserver = false,
        autoPlay = false,
        onMarkedAsDeleted = () => ({}),
    } = props;

    return (
        <StyledContentItemGrid data-rt="content-item-grid" className="lp_grid">
            {items.map((content, i: number) => {
                const contentItemIndex = i + 1;

                const gridItemProps: ContentItemProps = {
                    index: i,
                    content,
                    listId: id,
                    editModeActivated,
                    presentation,
                    preferredAccessVersion,
                    progress: getProgress(content, continueWatchingIsActive),
                    onClick: onItemClick,
                    onItemImpression,
                    itemPosition: contentItemIndex,
                    autoPlay,
                    onMarkedAsDeleted,
                };

                if (shouldUseIntersectionObserver) {
                    return (
                        <InView rootMargin="200px 0px" triggerOnce key={content.item.id}>
                            {({ inView, ref }) => (
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                <ContentItemGridBlock {...gridItemProps} forwardedRef={ref} inView={inView} />
                            )}
                        </InView>
                    );
                }

                // eslint-disable-next-line react/jsx-props-no-spreading
                return <ContentItemGridBlock key={content.item.id} {...gridItemProps} inView />;
            })}
        </StyledContentItemGrid>
    );
};

export default ContentItemGrid;
